
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';
import moment from 'moment';
import 'moment/locale/zh-cn';

import {classesApi, aiconfigApi} from '@/api';
import {aiConfigObj, frequencyAiTypes} from '@/js/aiConfig/aiconfig-list.helper';
const ROLES = ['research', 'teacher', 'student'];
const ROLE_LABELS = ['教研员', '教师', '学生'];
@Component
export default class school_AI_edit extends Vue {
    //===================================data区域begin
    expandedRowKeys: any = [];
    schoolAdress: any = '';
    orgName: any = '';
    schoolId: any = '';
    switchConfigFrequency: boolean = false;
    columnsConfig: any = [
        {
            dataIndex: 'serialNumber',
            title: '序号',
            scopedSlots: {customRender: 'serialNumber'},
            width: '6%'
        },
        {
            dataIndex: 'name',
            title: 'AI配置名称',
            scopedSlots: {customRender: 'name'}
        },
        {
            dataIndex: 'serviceLife',
            title: '配置使用期限',
            scopedSlots: {customRender: 'serviceLife'}
        },
        {
            dataIndex: 'creator.nickname',
            title: '配置人',
            scopedSlots: {customRender: 'nickname'}
        },
        {
            dataIndex: 'lastModified',
            title: '修改日期',
            scopedSlots: {customRender: 'lastModified'}
        },
        {
            dataIndex: 'status',
            title: '状态',
            scopedSlots: {customRender: 'status'}
        }
    ]; //总额概览配置
    columns: any = [
        {
            dataIndex: 'type',
            title: 'AI能力'
        },
        {
            dataIndex: 'max',
            scopedSlots: {customRender: 'max'},
            title: '使用配额'
        },
        {
            dataIndex: 'used',
            scopedSlots: {customRender: 'used'},
            title: '已使用配额'
        },
        {
            dataIndex: 'unUsed',
            scopedSlots: {customRender: 'unUsed'},
            title: '剩余额度'
        }
    ]; //总览概况
    //频次管理 ——因为使用了 customRender 和 customCell 所以需要写在 data 内
    get columnsFrequencyConfig() {
        const totalConfig = this.hasTotalConfig
            ? {
                  dataIndex: 'totalValue',
                  title: '总额度',
                  customRender: (value?: number) => {
                      return value || value === 0 ? value : '无限制';
                  }
              }
            : {};
        const columns = [
            {
                dataIndex: 'role',
                title: '角色',
                // scopedSlots: {customRender: 'role'},
                width: '8%',
                // @ts-ignore
                customRender: (value, row, index) => {
                    const obj = {
                        children: value,
                        attrs: {}
                    };
                    const aiTypesLength = frequencyAiTypes.length;
                    // 合并教研员、教师、学生列
                    if (index % aiTypesLength === 0) {
                        (obj.attrs as any).rowSpan = aiTypesLength;
                    } else {
                        (obj.attrs as any).colSpan = 0;
                    }
                    return obj;
                }
            },
            {
                dataIndex: 'aiName',
                title: 'AI能力',
                scopedSlots: {customRender: 'aiName'}
            },
            {
                dataIndex: 'frequency',
                title: '频率配置',
                scopedSlots: {customRender: 'frequency'}
            },
            {
                dataIndex: 'canUseTime',
                title: '可使用周期',
                scopedSlots: {customRender: 'canUseTime'}
            },
            {...totalConfig},

            {
                dataIndex: 'limitValue',
                title: '预警值',
                scopedSlots: {customRender: 'limitValue'}
            },
            {
                dataIndex: 'operation',
                title: '操作',
                scopedSlots: {customRender: 'operation'},
                // 合并修改列
                customCell: (record: any, rowIndex: any) => {
                    const aiTypesLength = frequencyAiTypes.length;
                    const index = ROLE_LABELS.findIndex(x => x === record.role);
                    if (index >= 0) {
                        return {
                            // 隐藏因为合并列导致的错位列
                            style: rowIndex % aiTypesLength === 0 ? '' : 'display: none',
                            attrs: {
                                rowSpan: aiTypesLength // 合并列数
                            }
                        };
                    }
                }
            }
        ];
        return columns;
    }
    // 总额概览配置列表数据
    configRows: any = [];
    // 总额概览配置列表的字列表-AI能力配置数量数据
    rows: any = [];
    // 频次管理表格数据
    frequencyRows: object = [];
    // 频次配置的id
    frequencyConfigId: any = '';
    // 频次表格记录 hover 状态
    leftAlignId: any = '';
    hasTotalConfig: boolean = false;
    //===================================data区域end

    //===================================computed区域begin
    //===================================computed区域end
    created() {
        this.hasTotalConfig = JSON.parse(window.localStorage.getItem('schoolInfo') as string).totalQuotaConfig === true;
        // 获取学校及行政区数据
        let value = window.localStorage.getItem('aicp_school_materials_$state_aicp_school_materials');
        this.schoolId = JSON.parse(value as string).schoolId;
        let isholdFrequency = window.localStorage.getItem('isFrequency');
        if (isholdFrequency == 'true') {
            this.switchConfigFrequency = true;
        }
        //获取学校信息
        this.initOrganization();
        //获取总额概览及频次管理初始数据
        this.getconfigList();
    }
    beforeDestroy() {
        window.localStorage.removeItem('isFrequency');
    }
    //===================================methods区域begin
    // 总额概览及频次管理切换
    switchConfig(flag: string) {
        if (flag === 'frequency') {
            window.localStorage.setItem('isFrequency', 'true');
            this.switchConfigFrequency = true;
        } else {
            window.localStorage.setItem('isFrequency', 'false');
            this.switchConfigFrequency = false;
        }
    }

    //展开子表格
    viewList(expanded: any, record: any) {
        // 只能同时展开一行子表格  https://blog.csdn.net/weixin_52691965/article/details/120494451?spm=1001.2101.3001.6650.4&depth_1-utm_source=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7ERate-4-120494451-blog-109360469.pc_relevant_multi_platform_whitelistv4
        if ((this.expandedRowKeys.length = 1)) {
            //进这个判断说明当前已经有展开的了
            //返回某个指定的字符串值在字符串中首次出现的位置，下标为0
            let index = this.expandedRowKeys.indexOf(record._id);
            if (index > -1) {
                //如果出现则截取这个id,1d到1相当于0，针对重复点击一个
                this.expandedRowKeys.splice(index, 1);
            } else {
                //如果没出现则截取所有id,添加点击id，0到1，针对已经有一个展开，点另一个会进入判断
                this.expandedRowKeys.splice(0, 1);
                this.expandedRowKeys.push(record._id);
            }
        } else {
            //数组长度小于0，说明都没展开，第一次点击，id添加到数组，数组有谁的id谁就展开
            this.expandedRowKeys.push(record._id);
        }
        this.$nextTick(() => {
            const e = document.querySelectorAll('.ant-table-expanded-row-level-1') as any;
            e.forEach((item: any) => {
                const elementRowKey = item.getAttribute('data-row-key');
                if (elementRowKey.includes(record._id)) {
                    (item.children[1] as any).setAttribute('colspan', 10);
                    (item.children[0] as any).style = 'display: none';
                }
            });
        });
        if (expanded && !record.overview['asr-rt'].max.toString().includes('秒')) {
            let formmatData: any = [];
            for (let i in record.overview) {
                if (i == 'asr-rt') {
                    // 使用配额
                    let timeData = moment.duration(record.overview[i].max / 1000, 'seconds');

                    if (timeData.days() == 0) {
                        record.overview[i].maxTime = timeData.hours() + '时' + timeData.minutes() + '分' + timeData.seconds() + '秒';
                        if (timeData.hours() == 0) {
                            record.overview[i].maxTime = timeData.minutes() + '分' + timeData.seconds() + '秒';
                            if (timeData.minutes() == 0) {
                                record.overview[i].maxTime = timeData.seconds() + '秒';
                                if (timeData.seconds() == 0) {
                                    record.overview[i].maxTime = '0秒';
                                }
                            }
                        }
                    } else {
                        record.overview[i].maxTime =
                            timeData.days() * 24 + timeData.hours() + '时' + timeData.minutes() + '分' + timeData.seconds() + '秒';
                    }
                    // 已使用配额
                    let timeData1 = moment.duration(record.overview[i].used / 1000, 'seconds');
                    if (timeData1.days() == 0) {
                        record.overview[i].usedTime = timeData1.hours() + '时' + timeData1.minutes() + '分' + timeData1.seconds() + '秒';
                        if (timeData1.hours() == 0) {
                            record.overview[i].usedTime = timeData1.minutes() + '分' + timeData1.seconds() + '秒';
                            if (timeData1.minutes() == 0) {
                                record.overview[i].usedTime = timeData1.seconds() + '秒';
                                if (timeData1.seconds() == 0) {
                                    record.overview[i].usedTime = '0秒';
                                }
                            }
                        }
                    } else {
                        record.overview[i].usedTime =
                            timeData1.days() * 24 + timeData1.hours() + '时' + timeData1.minutes() + '分' + timeData1.seconds() + '秒';
                    }
                    // 剩余额度
                    if (record.overview[i].max != record.overview[i].used) {
                        let unUsedTime = parseInt(record.overview[i].max) - parseInt(record.overview[i].used);
                        let timeData2 = moment.duration(unUsedTime / 1000, 'seconds');
                        if (timeData2.days() == 0) {
                            record.overview[i].unUsed = timeData2.hours() + '时' + timeData2.minutes() + '分' + timeData2.seconds() + '秒';
                            if (timeData2.hours() == 0) {
                                record.overview[i].unUsed = timeData2.minutes() + '分' + timeData2.seconds() + '秒';
                                if (timeData2.minutes() == 0) {
                                    record.overview[i].unUsed = timeData2.seconds() + '秒';
                                    if (timeData2.seconds() == 0) {
                                        record.overview[i].unUsed = '0秒';
                                    }
                                }
                            }
                        } else {
                            record.overview[i].unUsed =
                                timeData2.days() * 24 + timeData2.hours() + '时' + timeData2.minutes() + '分' + timeData2.seconds() + '秒';
                        }
                    } else {
                        record.overview[i].unUsed = '0秒';
                    }
                }
                Object.keys(record.overview).forEach(name => (record.overview[name].type = aiConfigObj[name]));

                formmatData.push(record.overview[i]);
            }
            this.rows = formmatData;
            // console.log(this.rows);
        }
    }

    // 修改角色频次
    onEditFrequency(record: any) {
        this.$router.push({
            path: '/school/aiconfig/ai_frequency_edit',
            query: {
                role: record.role,
                id: this.frequencyConfigId,
                schoolAdress: this.schoolAdress,
                orgName: this.orgName
            }
        });
        window.localStorage.setItem('isFrequency', 'true');
    }
    // 处理频次表格hover异常方法
    customRow(record: any) {
        return {
            style: {
                //样式
                'background-color': record.role === this.leftAlignId ? 'rgb(236,238,254)' : ''
            },
            on: {
                // 鼠标移入
                mouseenter: (event: any) => {
                    // 维护一个变量记录当前行id 因为我是根据id来进行行合并的
                    this.leftAlignId = record.role;
                },
                //移除 清除id 还原样式
                mouseleave: (event: any) => {
                    this.leftAlignId = '';
                }
            }
        };
    }
    //获取学校信息
    initOrganization() {
        let me = this;

        classesApi.getSchoolById({
            context: this,
            urlParamObj: {
                id: me.schoolId
            },
            success(data: any, parameters: any) {
                let domain = data.data;
                me.orgName = domain.name;
                me.schoolAdress = domain.address.replace(/\//g, '·');
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }

    // 获取目标学校的AI配置
    getconfigList() {
        let me = this;
        let data: any = {
            schoolId: me.schoolId,
            autoCreatedBySystem: true
        };
        aiconfigApi.getAIConfig({
            context: me,
            data: data,
            success(data: any, parameters: any) {
                let formmatData = data.data;
                //处理总额概览数据
                formmatData.forEach((item: any, i: number) => {
                    // 将 used 值格式化
                    if (item.used) {
                        Object.keys(item.overview).forEach(name => {
                            item.overview[name].used = item.used[name];
                        });
                    }
                    // 处理期限日期数据格式
                    item.serviceLife = item.from.substring(0, 10).replace(/-/g, '/') + '~' + item.to.substring(0, 10).replace(/-/g, '/');
                    item.lastModified = moment(item.lastModified).format('YYYY/MM/DD HH:mm:ss');
                });
                me.configRows = formmatData;

                for (let i = 0; i < me.configRows.length; i++) {
                    if (me.configRows[i].status == '已生效') {
                        me.expandedRowKeys.push(me.configRows[i]._id);
                        me.$nextTick(() => {
                            const e = document.querySelectorAll('.ant-table-expanded-row-level-1') as any;
                            e.forEach((item: any) => {
                                const elementRowKey = item.getAttribute('data-row-key');
                                if (elementRowKey && elementRowKey.includes(record._id)) {
                                    (item.children[1] as any).setAttribute('colspan', 10);
                                    (item.children[0] as any).style = 'display: none';
                                }
                            });
                        });
                        let record = me.configRows[i];
                        if (!record.overview['asr-rt'].max.toString().includes('秒')) {
                            let _formmatData: any = [];
                            Object.keys(record.overview).forEach(name => {
                                record.overview[name].type = aiConfigObj[name];
                            });
                            for (let i in record.overview) {
                                record.overview[i].index = i;

                                if (record.overview[i].type == aiConfigObj['asr-rt']) {
                                    // 使用配额
                                    let timeData = moment.duration(record.overview[i].max / 1000, 'seconds');

                                    if (timeData.days() == 0) {
                                        record.overview[i].maxTime =
                                            timeData.hours() + '时' + timeData.minutes() + '分' + timeData.seconds() + '秒';
                                        if (timeData.hours() == 0) {
                                            record.overview[i].maxTime = timeData.minutes() + '分' + timeData.seconds() + '秒';
                                            if (timeData.minutes() == 0) {
                                                record.overview[i].maxTime = timeData.seconds() + '秒';
                                                if (timeData.seconds() == 0) {
                                                    record.overview[i].maxTime = '0秒';
                                                }
                                            }
                                        }
                                    } else {
                                        record.overview[i].maxTime =
                                            timeData.days() * 24 +
                                            timeData.hours() +
                                            '时' +
                                            timeData.minutes() +
                                            '分' +
                                            timeData.seconds() +
                                            '秒';
                                    }
                                    // 已使用配额
                                    let timeData1 = moment.duration(record.overview[i].used / 1000, 'seconds');
                                    if (timeData1.days() == 0) {
                                        record.overview[i].usedTime =
                                            timeData1.hours() + '时' + timeData1.minutes() + '分' + timeData1.seconds() + '秒';
                                        if (timeData1.hours() == 0) {
                                            record.overview[i].usedTime = timeData1.minutes() + '分' + timeData1.seconds() + '秒';
                                            if (timeData1.minutes() == 0) {
                                                record.overview[i].usedTime = timeData1.seconds() + '秒';
                                                if (timeData1.seconds() == 0) {
                                                    record.overview[i].usedTime = '0秒';
                                                }
                                            }
                                        }
                                    } else {
                                        record.overview[i].usedTime =
                                            timeData1.days() * 24 +
                                            timeData1.hours() +
                                            '时' +
                                            timeData1.minutes() +
                                            '分' +
                                            timeData1.seconds() +
                                            '秒';
                                    }
                                    // 剩余额度
                                    if (record.overview[i].max != record.overview[i].used) {
                                        let unUsedTime = parseInt(record.overview[i].max) - parseInt(record.overview[i].used);
                                        let timeData2 = moment.duration(unUsedTime / 1000, 'seconds');
                                        if (timeData2.days() == 0) {
                                            record.overview[i].unUsed =
                                                timeData2.hours() + '时' + timeData2.minutes() + '分' + timeData2.seconds() + '秒';
                                            if (timeData2.hours() == 0) {
                                                record.overview[i].unUsed = timeData2.minutes() + '分' + timeData2.seconds() + '秒';
                                                if (timeData2.minutes() == 0) {
                                                    record.overview[i].unUsed = timeData2.seconds() + '秒';
                                                    if (timeData2.seconds() == 0) {
                                                        record.overview[i].unUsed = '0秒';
                                                    }
                                                }
                                            }
                                        } else {
                                            record.overview[i].unUsed =
                                                timeData2.days() * 24 +
                                                timeData2.hours() +
                                                '时' +
                                                timeData2.minutes() +
                                                '分' +
                                                timeData2.seconds() +
                                                '秒';
                                        }
                                    } else {
                                        record.overview[i].unUsed = '0秒';
                                    }
                                }
                                _formmatData.push(record.overview[i]);
                            }
                            me.rows = _formmatData;
                            // console.log(me.rows);
                        }
                    }
                }
                // console.log(me.configRows);

                //处理频次管理数据
                for (let i = 0; i < me.configRows.length; i++) {
                    if (me.configRows[i].status == '已生效') {
                        me.frequencyConfigId = me.configRows[i]._id;
                        // console.log(me.configRows[i].detail);
                        //将已生效的频次数据保存，用于频次修改时的回显
                        window.localStorage.setItem('frequencyData', JSON.stringify(me.configRows[i]));
                        // 处理频次数据
                        Object.keys(me.configRows[i].detail).forEach(roleName => {
                            const roleData = me.configRows[i].detail[roleName];
                            Object.keys(roleData).forEach(name => {
                                roleData[name].type = aiConfigObj[name];
                            });
                        });

                        //ai 能力
                        let frequencyList: any = Array(frequencyAiTypes.length * ROLE_LABELS.length)
                            .fill('')
                            .map(() => Object({}));
                        ROLES.forEach((role, roleIndex) => {
                            for (let aiTypeIndex = 0; aiTypeIndex < frequencyAiTypes.length; aiTypeIndex++) {
                                const totalIndex = roleIndex * frequencyAiTypes.length + aiTypeIndex;
                                const aiName = frequencyAiTypes[aiTypeIndex];
                                const roleAiItem = me.configRows[i].detail[role][aiName];
                                const frequencyItem = frequencyList[totalIndex];
                                //角色
                                frequencyItem['index'] = totalIndex;
                                frequencyItem['role'] = ROLE_LABELS[roleIndex];
                                frequencyItem.aiName = aiConfigObj[aiName];
                                if (roleAiItem) {
                                    //可使用周期
                                    frequencyItem.canUseTime =
                                        roleAiItem.from.substring(0, 10).replace(/-/g, '/') +
                                        '~' +
                                        roleAiItem.to.substring(0, 10).replace(/-/g, '/');
                                    // 频率配置、预警值
                                    if (aiName === 'asr-rt') {
                                        frequencyItem.frequency = roleAiItem.per + roleAiItem.max / 60000 + '分钟';
                                        frequencyItem.limitValue = roleAiItem.threshold / 60000;
                                        frequencyItem.totalValue = roleAiItem.total ? roleAiItem.total / 60000 : '';
                                    } else {
                                        frequencyItem.frequency = roleAiItem.per + roleAiItem.max + '次';
                                        frequencyItem.limitValue = roleAiItem.threshold;
                                        frequencyItem.totalValue = roleAiItem.total;
                                    }
                                } else {
                                    frequencyItem.canUseTime = '';
                                    frequencyItem.frequency = '';
                                    frequencyItem.limitValue = '';
                                    frequencyItem.totalValue = '';
                                }
                            }
                        });
                        for (let p = 0; p < frequencyList.length; p++) {
                            if (frequencyList[p].frequency.includes('week')) {
                                frequencyList[p].frequency = frequencyList[p].frequency.replace('week', '周限额：');
                            } else {
                                frequencyList[p].frequency = frequencyList[p].frequency.replace('day', '日限额：');
                            }
                        }
                        me.frequencyRows = frequencyList;
                    }
                }
            }
        });
    }
    //===================================methods区域end
}
